import { createSlice } from "@reduxjs/toolkit";
import { adminThemeSaleList } from "./ThunkAction";
import { iThemeState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iThemeState = {
  isLoading: false,
  adminThemeList:[],
  errorMessage: null,
};
export const adminThemeSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetThemeState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminThemeSaleList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(adminThemeSaleList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.adminThemeList = payload.data.data; 
          state.isLoading = false;
        }
      })
      .addCase(adminThemeSaleList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch data";
        state.isLoading = false;
      });
  },
});

export const { resetThemeState } = adminThemeSlice.actions;
export default adminThemeSlice.reducer;
